import React from 'react'
import moment from 'moment'
import {
  Timeline,
  Loader,
  ModalStatus,
  ModalBookingList,
  ModalDelete,
  Topbar,
  ModalInformation
} from '../../../components'
import {
  getCalendarString,
  getLocaleTimeString,
  getNearestMinute,
  MODAL_STATUS,
  CREATE_DEFAULT,
  CREATE_BOOKING,
  MENU,
  ROUTE,
  checkPermission,
  cutString2,
  SPACE_STATUS,
  FALLBACK_SPACE_TYPE_THEME,
  ROOM_TEXT,
  TABLE
} from '../../../helpers'
import apiService from '../../../reduxs/apiService'
import Style from './style'
import { StyleListFloor } from '../style'
import { COLOR, IMG } from '../../../themes'

const oneHourTimeStamp = 1000 * 60 * 60
const oneDayTimeStamp = oneHourTimeStamp * 24
const timezoneOffset = new Date().getTimezoneOffset() * 1000 * 60

class RoomTimeline extends React.Component {
  constructor(props) {
    super(props)
    const now = new Date().valueOf()
    const todayTimestamp = Math.floor(now / oneDayTimeStamp) * oneDayTimeStamp
    let selectedDate = this.initDatetime(new Date(props.params.year, props.params.month - 1, props.params.date, 0, -new Date().getTimezoneOffset()))
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date(todayTimestamp)
    this.initialState = {
      minuteStep: 15,
      isHiding: true,
      isLoading: true,
      scrollToView: true,
      bookingList: [],
      event: null,
      selectedData: null,
      selectedDate: selectedDate,
      selectedRoom: null,
      selectedCompany: null,
      selectedBuilding: null,
      selectedFloor: null,
      isShowDetail: false,
      permission: {
        read: checkPermission(props.permission, ROUTE.FLOORPLAN.CODE),
        create: checkPermission(props.permission, ROUTE.FLOORPLAN.ACTION.CREATE)
      },
      isHideDeleteIcon: false,
      position: { x: 0, y: 0 },
      headerName: null,
      descriptionName: null,
      buttonName: null,
      statusFav: '',
    }
    if (!props.params.roomId || isNaN(props.params.roomId)) {
      props.history.push('')
    }
    this.state = this.initialState
  }

  componentDidMount () {
    const { displayDate, getListHoliday, accountReducer } = this.props
    const startDateString = [displayDate.getFullYear(), '01', '01'].join('-')
    const endDateString = [displayDate.getFullYear(), '12', '31'].join('-')
    const props = { ...this.props }
    const { selectedDate } = this.state
    const startDatetime = moment(selectedDate).format('YYYY-MM-DD 00:00:00')
    const endDatetime = moment(selectedDate).format('YYYY-MM-DD 23:59:59')

    const params = {
      roomId: props.params.roomId,
      startDatetime,
      endDatetime,
      sorts: JSON.stringify([
        {
          type: 'ASC',
          column: 'startDatetime'
        },
        {
          type: 'DESC',
          column: 'endDatetime'
        }
      ]),
      status: '[0,1,2]',
      status: '[0,1,2]',
    }
    this.getDetailRoom(props.params.roomId, () => this.getBookingList(params))
    this.props.roomAction.getDetailRoomV2({ roomId: props.params.roomId })

    getListHoliday({
      startDatetime: startDateString,
      endDatetime: endDateString,
      companyId: accountReducer.user.companyId,
      limit: 999
    })
  }

  componentDidUpdate () {
    const props = { ...this.props }
    let selectedDate = new Date(props.params.year, props.params.month - 1, props.params.date, 0, -new Date().getTimezoneOffset())
    if (isNaN(selectedDate.valueOf())) selectedDate = new Date()
    if (selectedDate.valueOf() !== this.state.selectedDate.valueOf()) {
      const newState = {
        minuteStep: 15,
        isHiding: false,
        isLoading: false,
        scrollToView: false,
        selectedDate: selectedDate
      }
      Object.assign(this.initialState, newState)
      this.setState(newState)
      if (props.params.roomId && !isNaN(props.params.roomId)) {
        const startDatetime = moment(selectedDate).format('YYYY-MM-DD 00:00:00')
        const endDatetime = moment(selectedDate).format('YYYY-MM-DD 23:59:59')

        const params = {
          roomId: props.params.roomId,
          startDatetime,
          endDatetime,
          sorts: JSON.stringify([
            {
              type: 'ASC',
              column: 'startDatetime'
            },
            {
              type: 'DESC',
              column: 'endDatetime'
            }
          ]),
          status: '[0,1,2]',
        }
        this.getBookingList(params)
        this.props.roomAction.getDetailRoomV2({ roomId: props.params.roomId })
      } else {
        props.history.push('')
      }
    }
  }

  handleClickTimeline (timestamp) {
    const { permission } = this.state
    const endDatetimeOffset = oneHourTimeStamp
    const selectedDate = new Date(timestamp + timezoneOffset)
    const selectedEndTime = this.initDatetime(new Date(timestamp + endDatetimeOffset + timezoneOffset))
    const dateString = [selectedDate.getFullYear(), (selectedDate.getMonth() + 1).toString().padStart(2, 0), selectedDate.getDate().toString().padStart(2, 0)].join('-')
    const startTimeString = [selectedDate.getHours().toString().padStart(2, 0), selectedDate.getMinutes().toString().padStart(2, 0)].join(':')
    const endTimeString = [selectedEndTime.getHours().toString().padStart(2, 0), selectedEndTime.getMinutes().toString().padStart(2, 0)].join(':')
    
    if (permission.create) {
      const fromParam = this.props.isFloorPlan ? 'floorplan_timeline' : 'meetingroom_timeline'
      this.props.history.push(`${ROUTE.BOOKING.LINK}?date=${dateString}&startTime=${startTimeString}&endTime=${endTimeString}&roomId=${this.state.selectedRoom.id}&from=${fromParam}`)
    }
  }

  handleClickEvent (event, data) {
    const { accountReducer } = this.props
    const { user: { username } } = accountReducer

    this.setState({
      isHideEditIcon: username !== data.owner,
      isHideDeleteIcon: username !== data.owner,
    })

    event.persist()
    const boundingBox = event.currentTarget.parentElement.parentElement.parentElement.getBoundingClientRect()
    const mousePos = event.clientX - boundingBox.x
    const percentPos = Math.round(mousePos / boundingBox.width * 100)
    const position = {}
    if (percentPos < 33) {
      position.showRight = true
    } else if (percentPos > 66) {
      position.showLeft = true
    } else {
      position.showCenter = true
    }
    if (this.state.isShowDetail) {
      this.setState({
        isShowDetail: false
      }, () => {
        this.setState({
          event: {
            clientX: mousePos,
            clientY: event.clientY,
            date: new Date().toISOString(),
            ...position
          },
          selectedData: {
            ...data,
            id: data.id,
            title: data.projectName,
            day: getCalendarString(data.startDatetime, this.props.language),
            location: data.roomName,
            time: `${moment(data.startDatetime).utc().format('HH:mm')} - ${moment(data.endDatetime).utc().format('HH:mm')}`,
            timeStart: `${getLocaleTimeString(data.startDatetime)}`,
            detail: data.owner,
            status: data.status,
            description: data.description ? data.description : 'No data.'
          },
          isShowDetail: true,
          scrollToView: false
        })
      })
    } else {
      this.setState({
        event: {
          clientX: mousePos,
          clientY: event.clientY,
          date: new Date().toISOString(),
          ...position
        },
        selectedData: {
          ...data,
          id: data.id,
          title: data.projectName,
          day: getCalendarString(data.startDatetime, this.props.language),
          location: data.roomName,
          time: `${moment(data.startDatetime).utc().format('HH:mm')} - ${moment(data.endDatetime).utc().format('HH:mm')}`,
          timeStart: `${getLocaleTimeString(data.startDatetime)}`,
          detail: data.owner,
          status: data.status,
          description: data.description ? data.description : 'No data.'
        },
        isShowDetail: true,
        scrollToView: false
      })
    }
  }

  goBack () {
    this.props.history.goBack()
  }

  closeModal = () => {
    const { modalAction } = this.props
    modalAction.closeModalInformation()
  }

  getBookingList (param) {
    this.setState({
      isLoading: true
    })
    return apiService.get('rest/v2/getlist_booking', { ...param, showPrivateSubject: true }).then((res) => {
      this.setState({
        isLoading: false,
        isHiding: false
      })
      if (res.status) {
        const bookingListRoom = res.data.list
        const id = this.state.id
        let index = -1
        for (const booking of bookingListRoom) {
          if (booking.bookingId === id) break
          index = index + 1
        }
        if (index >= 0 && index < bookingListRoom.length - 1) {
          bookingListRoom.splice(index, 1)
        }
        this.setState({
          bookingList: bookingListRoom
        })
      } else if (!res.status) {
        this.props.openModalStatus(res)
      } else {
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }

  getDetailRoom (roomId, func) {
    apiService.get('rest/v1/getdetail_room', {
      roomId: roomId
    }).then((res) => {
      if (res.status) {
        const room = res.data
        let minuteStep = 15
        try {
          minuteStep = room.minuteStep
        } catch (_) {

        }
        const newState = {
          minuteStep: minuteStep,
          selectedRoom: {
            id: room.roomId,
            name: room.roomName
          },
          selectedCompany: {
            id: room.companyId,
            name: room.companyName
          },
          selectedBuilding: {
            id: room.buildingId,
            name: room.buildingName
          },
          selectedFloor: {
            id: room.floorId,
            name: room.floorLevel
          },
          roomName: room.roomName,
          lockRoom: true,
          isLoading: false
        }
        Object.assign(this.initialState, newState)
        this.setState(newState)
        func()
      } else if (!res.status) {
        this.props.openModalStatus(res)
      } else {
        console.log('ERROR ACTION getListAllBooking2', res)
      }
    })
  }

  deleteBooking (deletedReason) {
    this.setState({
      isLoading: true,
      scrollToView: false,
      isShowDetail: false,
      selectedData: null,
      event: null
    })
    apiService.post('rest/v1/delete_booking', {
      bookingId: this.state.selectedData.id,
      deletedReason: deletedReason
    }).then((res) => {
      this.props.closeModalConfirm()
      if (res.status) {
        const { year, month, date, roomId } = this.props.params
        const selectedDate = new Date(year, month - 1, date)
        const startDatetime = moment(selectedDate).format('YYYY-MM-DD 00:00:00')
        const endDatetime = moment(selectedDate).format('YYYY-MM-DD 23:59:59')

        const params = {
          roomId,
          startDatetime,
          endDatetime,
          sorts: JSON.stringify([
            {
              type: 'ASC',
              column: 'startDatetime'
            },
            {
              type: 'DESC',
              column: 'endDatetime'
            }
          ]),
          status: '[0,1,2]',
        }
        this.getBookingList(params, () => this.setState({ scrollToView: false }))
      } else if (!res.status) {
        this.setState({
          isLoading: false
        })
        this.props.openModalStatus(res)
      } else {
        this.setState({
          isLoading: false
        })
        console.log('ERROR ACTION createBuilding', res)
      }
    })
  }

  initDatetime (selectedDate) {
    const minuteStep = this.state && this.state.minuteStep ? this.state.minuteStep : 15
    let minute = getNearestMinute(selectedDate.getMinutes(), minuteStep, 1)
    let hour = selectedDate.getHours()
    let now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    if (minute >= 60) {
      minute = 0
      hour = hour + 1
      if (hour >= 24) {
        now = null
      }
    }
    if (now !== null) now = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate(), hour, minute)
    return now
  }

  openModalInformation = (event, dataInfo) => {
    event.stopPropagation()
    event.preventDefault()
    const {
      modalAction
    } = this.props
    this.setState({
      headerName: dataInfo.headerName,
      descriptionName: dataInfo.descriptionName,
      buttonName: dataInfo.buttonName,
    }, () => {
      modalAction.openModalInformation()
    })
  }

  openModalConfirm = () => {
    const {
      modalAction
    } = this.props
    modalAction.openModalConfirm()
  }

  getStartDateTimestamp (currentTimestamp) {
    return Math.floor(currentTimestamp / oneDayTimeStamp) * oneDayTimeStamp
  }
  goToFloorPlanTimeLine = () => {
    const { history, params } = this.props
    history.push(`${ROUTE.FLOORPLAN.LINK}/${params.year}/${params.month}/${params.date}`)
  }
  setFav = (status) => {
    const { params } = this.props
    const { roomAction, roomReducer, accountReducer } = this.props
    const roomId = params.roomId

    if (status) {
      roomAction.clearFavouriteData({
        roomId: Number(roomId),
        companyId: Number(roomReducer.detailRoom?.company?.id),
        username: accountReducer.user.username,
      }, () => {
        this.setState({ statusFav: 0 })
      })
    } else {
      roomAction.saveFavouriteData({
        roomId: Number(roomId),
        companyId: Number(roomReducer.detailRoom?.company?.id),
        username: accountReducer.user.username,
      }, () => {
        this.setState({ statusFav: 1 })
      })
    }
  }

  displayDataName = () => {
    const { roomReducer, accountReducer, settingReducer } = this.props
    const detailRoom = roomReducer?.detailRoom
    if (!detailRoom) return null

    const roomName = detailRoom.name || this.state.selectedRoom?.name || ''
    const companyName = detailRoom.company?.name || ''
    const floorStr = detailRoom.floor?.floorLevel ? `Floor ${detailRoom.floor.floorLevel}` : ''
    const zoneStr = detailRoom.building?.name || '' 
    const subTitle = [companyName, floorStr, zoneStr].filter(Boolean).join(', ')
    
    const capacity = detailRoom.capacity || 0
    const memberLabel = capacity > 1 ? ROOM_TEXT.MEMBER[accountReducer.language] : ROOM_TEXT.PERSON[accountReducer.language]
    const member = `( ${capacity} ${memberLabel} )`

    let isBusy = false
    const listBooking = this.state.bookingList
    const bookingLength = listBooking && listBooking.length > 0

    if (listBooking && bookingLength) {
      const timeNow = moment(new Date()).format('HH:mm')
      const newStartTime = moment(listBooking[0].startDatetime).format('HH:mm')
      const newEndTime = moment(listBooking[0].endDatetime).format('HH:mm')

      if (newStartTime < timeNow && newEndTime > timeNow) {
        isBusy = true
      }
    }

    const statusKey = isBusy ? SPACE_STATUS.BUSY : SPACE_STATUS.AVAILABLE
    const statusLabel = SPACE_STATUS.LABEL[statusKey]
    const statusTextColor = SPACE_STATUS.COLOR[statusKey].text
    const statusBgColor = SPACE_STATUS.COLOR[statusKey].bg

    const spaceType = detailRoom.spaceType || 'room'
    const parsedThemeConfig = settingReducer.settingTheme?.themeConfig || {}
    const spaceTypeTheme = parsedThemeConfig?.spaceType?.[spaceType]
    
    const defaultSpaceType = FALLBACK_SPACE_TYPE_THEME[spaceType] || FALLBACK_SPACE_TYPE_THEME.other
    const spaceTypeBg = spaceTypeTheme?.background || defaultSpaceType.bg
    const spaceTypeColor = spaceTypeTheme?.foreground || defaultSpaceType.text
    const displaySpaceType = spaceType ? spaceType.charAt(0).toUpperCase() + spaceType.slice(1) : ''

    const bookmarkColor = settingReducer.settingTheme?.colorTheme || '#CFB58F'
    const { statusFav } = this.state
    const isFavorite = statusFav === '' ? detailRoom.isFavourite : statusFav
    const bookmarkIcon = isFavorite ? 'ic_press-bookmark-on.svg' : 'ic_press-bookmark-off.svg'

    return (
      <div className='detail-room-header' style={{ width: '100%' }}>
        <div className='head_title'>
          <div className='head_left'>
            <div className='room_name'>{cutString2(roomName, 20)}</div>
            {spaceType && (
              <div 
                className='type-badge' 
                style={{ backgroundColor: spaceTypeBg, color: spaceTypeColor }}
              >
                {displaySpaceType}
              </div>
            )}
          </div>
          <div className='head_right'>
            <div 
              className='favorite-icon' 
              onClick={() => this.setFav(isFavorite)}
            >
              <div 
                style={{
                  width: '24px',
                  height: '24px',
                  backgroundColor: bookmarkColor,
                  WebkitMask: `url(${IMG[bookmarkIcon]}) no-repeat center`,
                  WebkitMaskSize: 'contain',
                  mask: `url(${IMG[bookmarkIcon]}) no-repeat center`,
                  maskSize: 'contain',
                  cursor: 'pointer'
                }}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }

  render () {
    const {
      openModalConfirm,
      modalStatus,
      modalReducer,
      closeModalStatus,
      closeModalConfirm,
      language,
      history,
      accountReducer,
      holidayReducer,
      colorTheme,
      modalAction,
    } = this.props
    const {
      selectedData,
      isShowDetail,
      isLoading,
      bookingList,
      selectedDate,
      selectedRoom,
      className,
      isHiding,
      scrollToView,
      event,
      isHideEditIcon,
      isHideDeleteIcon,
      position,
      headerName,
      descriptionName,
      buttonName
    } = this.state

    const today = new Date(this.getStartDateTimestamp(selectedDate.valueOf() - timezoneOffset))

    let dataModal
    if (selectedData) {
      let start = new Date(selectedData.startDatetime)
      let end = new Date(selectedData.endDatetime)

      start.setHours(start.getHours() - 7)
      end.setHours(end.getHours() - 7)

      dataModal = [{
        id: selectedData.id,
        title: selectedData.title,
        day: getCalendarString(start, language),
        location: selectedData.roomName,
        time: `${getLocaleTimeString(start)} - ${getLocaleTimeString(end)}`,
        startTime: `${getLocaleTimeString(start)}`,
        description: selectedData.description,
        status: selectedData.status,
        owner: selectedData.owner,
        meetingLink: selectedData.meetingLink,
        meetingLinkType: selectedData.meetingLinkType,
        isEditable: selectedData.isEditable
      }]
    }

    return (
      <StyleListFloor className={className}>
        <Topbar
          onClickBackToBeforePage={this.goToFloorPlanTimeLine}
          textBreadcrumbStart={MENU.FLOOR_PLAN[language]}
          textBreadcrumbEnd={TABLE.TIME_SLOT[language]}
        />

        {isLoading && <Loader colorTheme={colorTheme} />}
        {!isHiding &&
          <Style className={className}>
            <section style={{ marginTop: '92px', padding: '0 24px' }} className='room-header'>
              {this.displayDataName()}
            </section>
            <Timeline
              holidayListName={holidayReducer.listHoliday ? holidayReducer.listHoliday : []}
              holidayList={holidayReducer.listHoliday.map((holiday) => new Date(holiday.date).valueOf())}
              bookingList={bookingList}
              startDatetimeContent={today}
              endDatetimeContent={today}
              scrollToView={scrollToView}
              handleClickTimeline={(timeStamp) => this.handleClickTimeline(timeStamp)}
              handleClickEvent={(event, data) => this.handleClickEvent(event, data)}
              startOperatingTime={accountReducer.user.startOperatingTime}
              endOperatingTime={accountReducer.user.endOperatingTime}
              minuteStep={accountReducer.user.minuteStep}
              headerType='close'
              colorTheme={colorTheme}
            />
          </Style>}
        {isShowDetail
          ? (
            <ModalBookingList
              data={dataModal}
              history={history}
              event={event}
              position={position}
              typeModal='content'
              showCenter={event.showCenter}
              showLeft={event.showLeft}
              showRight={event.showRight}
              language={language}
              closeModal={() => this.setState({
                isShowDetail: false,
                selectedData: null,
                event: null
              })}
              deleteBooking={() => {
                openModalConfirm()
              }}
              permission={accountReducer.permission}
              isFloorPlan={true}
              isHideEditIcon={isHideEditIcon}
              isHideDeleteIcon={isHideDeleteIcon}
              modalReducer={modalReducer}
              modalAction={modalAction}
              onClickInformation={(event, dataInfo) => this.openModalInformation(event, dataInfo)}
              onClickConfirm={() => this.openModalConfirm()}
            />)
          : null}
        {(modalStatus) &&
          <ModalStatus
            language={language}
            code={modalStatus.code}
            action={modalStatus.status
              ? CREATE_DEFAULT.EDIT[language]
              : MODAL_STATUS.WARNING[language]}
            text={modalStatus.status
              ? MODAL_STATUS.SUCCESS[language]
              : modalStatus.description}
            status={modalStatus.status}
            onClick={modalStatus.status || modalStatus.doGoBack ? () => {
              closeModalStatus()
              this.goBack()
            } : closeModalStatus}
            colorTheme={colorTheme}
          />}
        {modalReducer.confirm && selectedData &&
          <ModalDelete
            language={language}
            name={selectedData.projectName}
            onClickCancel={() => {
              this.setState({
                isShowDetail: false,
                selectedData: null,
                event: null
              })
              closeModalConfirm()
            }}
            onClickAction={(deletedReason) => this.deleteBooking(deletedReason)}
            validate={modalReducer.validate}
            colorTheme={colorTheme}
          />}

        {modalReducer.isOpenModalInformation && <ModalInformation
          headerName={headerName}
          colorTheme={colorTheme}
          descriptionName={descriptionName}
          buttonName={buttonName}
          onClick={this.closeModal}
        />}
      </StyleListFloor>
    )
  }
}

export default RoomTimeline
